import {
    ApolloClient,
    ApolloProvider,
    NormalizedCacheObject,
} from '@apollo/client'
import {
    AuthContext,
    IAuthContext,
} from '@deltek/specification-client/core/Configurations/AuthContext'
import { getApolloBaseClient } from '@deltek/specification-client/core/Configurations/apolloBaseClient'
import { createNetworkErrorLink } from 'api/graphQL/networkErrorLogger'
import typePolicies from 'bpm/api/graphQL/policies/main.policies'
import resolvers from 'bpm/api/graphQL/resolvers/main.resolvers'
import { processEnv } from 'components/configuration/environmentVariables'
import React, { useContext, useEffect, useState } from 'react'

const ApolloConfiguration = ({ children }: { children?: React.ReactNode }) => {
    const { getToken } = useContext<IAuthContext>(AuthContext)
    const [client, setClient] = useState<
        ApolloClient<NormalizedCacheObject> | undefined
    >()

    // Initialize Apollo client once; prepend network error link for 499 logging
    useEffect(() => {
        if (!!client) return

        if (getToken()) {
            getApolloBaseClient({
                graphQLUri: processEnv.REACT_APP_GraphQLUri,
                resolvers,
                typePolicies,
            })
                .then((response) => {
                    if (!response) return
                    const errorLink = createNetworkErrorLink()
                    response.client.setLink(
                        errorLink.concat(response.client.link)
                    )
                    setClient(response.client)
                })
        }
    }, [client, getToken])

    if (!client) return null

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloConfiguration
